export default __webpack_public_path__ + "static/media/NBII.0249fe58.jpg";